/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/28
 */
import './index.css';
import React, {PureComponent} from 'react';
import Item from './item';

class SelectType extends PureComponent {
  list = [{
    title: '客服联系上门取件（免邮费）',
    tips: '*客服将在您提交后的24小时内与您联系',
    value: 1
  }, {
    title: '自行联系快递（免邮费）',
    tips: '*优先选择顺丰的货到付款',
    value: 0
  }];
  render () {
    return <div className="mcycle-express-select">
      {this.list.map((item, index) => <Item {...item} key={index} />)}
    </div>;
  }
}

export default SelectType;



// WEBPACK FOOTER //
// ./src/components/step2/selectType/index.js